import * as tslib_1 from "tslib";
import addFileProviderService from '../services/addFileProvider';
import datapoints from '../datapoints';
import { action } from 'satcheljs/lib/legacy';
import { getAuthWindowInfo } from './helpers/AuthWindowInfo';
import { parse } from 'querystring';
/**
 * In adding provider we do the following
 * 1- Validate the CSRF token
 * 2- Get the OAuth token and add the provider
 * 3- Create and return the provider view state of the newly created provider
 */
// Exported only for testing
// FPAddDataProvider has customData that is called on the addFileProviderToUserAccount input parameters.
// If you change the input params make sure to update FPAddDataProvider in datapoints.ts to match.
export default action('addFileProviderToUserAccount', datapoints.FPAddDataProvider)(function addFileProviderToUserAccount(redirectUrl, providerType, getAddableFileProviderInfoFunc) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var queryStringStartIndex, queryString, queryStringValues, _a, getCSRFToken, getOAuthCode, csrfTokenReceived, authWindowInfo, oAuthCode, response;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryStringStartIndex = redirectUrl.indexOf('?');
                    queryString = queryStringStartIndex !== -1 ? redirectUrl.slice(queryStringStartIndex + 1) : '';
                    queryStringValues = parse(queryString);
                    _a = getAddableFileProviderInfoFunc(providerType), getCSRFToken = _a.getCSRFToken, getOAuthCode = _a.getOAuthCode;
                    csrfTokenReceived = getCSRFToken(queryStringValues);
                    authWindowInfo = getAuthWindowInfo(providerType).info;
                    if (csrfTokenReceived !== authWindowInfo.csrfToken) {
                        throw new Error('Invalid CSRF token');
                    }
                    oAuthCode = getOAuthCode(queryStringValues);
                    if (!oAuthCode) {
                        throw new Error('OAuth code not found');
                    }
                    return [4 /*yield*/, addFileProviderService(providerType, oAuthCode, authWindowInfo.redirectUrl, authWindowInfo.updateProvider)];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.NewProvider];
            }
        });
    });
});
//# sourceMappingURL=addFileProviderToUserAccount.js.map